<template>
  <div class="busReport">
    <div class="busReport__header">
      <div class="busReport__header__back" @click.stop="goToAllCampaign()">
        <span class="busReport__header__back__icon"><i class="adx-ic_arrow_left"></i></span>
        <span class="busReport__header__back__all subhead">Transit Advertising</span>
      </div>
      <div class="busReport__header__title">
        <div class="campaignName">
          <h1 class="medium-title">{{campaign.title}}</h1>
        </div>
      </div>
    </div>
    <template>
      <div class="busReport__graph">
        <div class="busReport__graph__header">
          <div class="busReport__graph__header__left">
            <span class="small-title strong"> Overview</span>
          </div>
          <!-- Filter option -->
          <div class="busReport__graph__header__right">
            <div class="filter">
              <dropdown-filter-date @selected="selectDateFilter" :list="dateList" labelButton='All Time' :startDate.sync="dateRange.start" :endDate.sync="dateRange.end" />
            </div>
            <div class="group">
              <adx-group-button :list="filterList" @selectedButton="selectFilter" :isDisabled="disabledList"/>
            </div>
          </div>
        </div>
        <!-- Measurement display -->
        <div class="busReport__graph__card">
          <div class="card pointer" :class="{active : toggle.impression}" @click.stop="toggleTo('impression')">
            <div class="card__title small-font">TOTAL IMPRESSIONS</div>
            <template>
              <div v-if="loaded" class="card__number break-word medium-title ">{{ totalMeasurement.impression | formatNumber}}</div>
              <div v-else class="card__number large-title">{{ '-' }}</div>
            </template>
          </div>
          <div class="card" :class="{active : toggle.distance}">
            <div class="card__title small-font">TOTAL DISTANCE (KM)</div>
            <template>
              <div class="card__number break-word medium-title ">{{ totalMeasurement.distance ? displayKilometers(totalMeasurement.distance) : '-'}}</div>
            </template>
          </div>
          <div class="card pointer" :class="{active : toggle.totalSnap}" @click.stop="toggleTo('totalSnap')">
            <div class="card__title small-font">SNAP IMPRESSIONS</div>
            <template>
              <div class="card__number medium-title ">
                <div class="card__number medium-title ">{{ totalMeasurement.snap ? displayPercentage(totalMeasurement.snap) : '-' }}</div>
              </div>
            </template>
          </div>
          <div class="card pointer" :class="{active : toggle.totalFair}" @click.stop="toggleTo('totalFair')">
            <div class="card__title small-font">FAIR IMPRESSIONS</div>
            <template>
              <div class="card__number medium-title ">{{ totalMeasurement.fair ? displayPercentage(totalMeasurement.fair) : '-' }}</div>
            </template>
          </div>
          <div class="card pointer" :class="{active : toggle.totalCaptive}" @click.stop="toggleTo('totalCaptive')">
            <div class="card__title small-font">CAPTIVE IMPRESSIONS</div>
            <template>
              <div class="card__number medium-title ">{{ totalMeasurement.captive ? displayPercentage(totalMeasurement.captive) : '-' }}</div>
            </template>
          </div>
        </div>
        <!-- Graph display -->
        <div class="busReport__graph__content">
          <adx-line-chart v-if="loaded && !isLoading && !isEmpty" :chartdata.sync="chartData" :options="options" />
          <adx-empty-selection v-else-if="isEmpty && !isLoading" />
          <adx-loading-primary v-else/>
        </div>
      </div>
       <!-- Report display -->
      <div class="busReport__report">
        <div class="busReport__report__sidemenu">
          <ul>
            <router-link tag="li" :to="{name: 'measurementbusroutes', query : this.query_router}" class="subhead">Routes</router-link>
            <router-link tag="li" :to="{name: 'measurementbusvehicle', query : this.query_router}" class="subhead">Vehicle</router-link>
            <router-link tag="li" :to="{name: 'measurementbuscoverage', query : this.query_router}" class="subhead">Coverage</router-link>
          </ul>
        </div>
        <div class="busReport__report__content">
          <router-view :start_date="startParam" :end_date="endParam" :idParent="orderId" :key="childParam"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import LineChart from '@/components/Chart/LineChart'
import LoadingPrimary from '@/components/Loading/Primary'
import GroupButton from '@/components/GroupButton'
import DropdownDateFilter from '@/components/Dropdown/FilterDateDropdown'
import EmptySelection from '@/components/NotFound/Selection'
import lib from '@/lib/util'
import formatMoney from 'accounting-js/lib/formatMoney.js'
import moment from 'moment'
import axios from 'axios'
import _ from 'lodash'
import { restEdge } from "@/api/edgeUrls"

import { mapGetters } from 'vuex'
import { formatShortDate, dateFormat } from '@/lib/util'
import { parseErrorGql } from '@/lib/error'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { apiUrls } from '@/api/measurementUrls'

export default {
  name: 'adx-campaignreport-audience',
  components: {
    'adx-line-chart': LineChart,
    'adx-loading-primary': LoadingPrimary,
    'adx-group-button': GroupButton,
    'dropdown-filter-date':DropdownDateFilter,
    'adx-empty-selection': EmptySelection,
  },
  props: {

  },
  data() {
    return {
      orderId: null,
      measurementData: [],
      chartData: [],
      period: null,
      startPeriod: null,
      endPeriod: null,
      campaign: {
        title : null,
        start: null,
        end: null,
      },
      totalMeasurement:{
        impression: null,
        distance: null,
        fair: null,
        snap: null,
        captive: null
      },
      dateRange: {
        start : null,
        end : null
      },
      toggle: {
        impression: true,
        distance: false,
        totalSnap: false,
        totalFair: false,
        totalCaptive: false,
      },
      isLoading: true,
      query_router: null,
      selectedDate: 'alltime',
      selectedType: 'impression',
      selectedFilter: 'day',
      startParam: null,
      endParam: null,
      childParam: null,
      loaded: false,
      filterList: [
        {
          'id': 0,
          'label': 'Hour',
          'value': 'hour',
        },
        {
          'id': 1,
          'label': 'Day',
          'value': 'day',
        },
        {
          'id': 2,
          'label': 'Week',
          'value': 'week',
        },
        {
          'id': 3,
          'label': 'Month',
          'value': 'month',
        },
      ],
      disabledList: [
        'hour'
      ],
      dateList: [
        {
          'id': 0,
          'label': 'Today',
          'value': 'today',
        },
        {
          'id': 1,
          'label': 'Last 7 Days',
          'value': '7-days',
        },
        {
          'id': 2,
          'label': 'Last 30 Days',
          'value': '30-days',
        },
        {
          'id': 3,
          'label': 'All Time',
          'value': 'alltime',
        },
        {
          'id': 4,
          'label': 'Custom Date',
          'value': 'customdate',
        },
      ],
      options: {
        responsive: true, 
        maintainAspectRatio: false, 
        legend: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              },
              ticks: {
                maxTicksLimit : 15,
                maxRotation : 0,
                callback: label => {
                  return label
                }
              }
            },
          ],
          yAxes: [{
            ticks: {
              //In this callback we can format data displayed at yAxes
              callback: (value, index, values) => {
                return this.getFormatNumber(value);
              },
              // stepSize: 10,
              beginAtZero: true
            }
         }]
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    isEmpty: function(){
      return this.measurementData && this.measurementData.length ? false: true
    }
  },
  watch: {
    selectedDate(value) {
      if (value == 'today') {
        this.dateRange.start = moment().utcOffset(7).format('YYYY-MM-DD')
        this.dateRange.end = moment().utcOffset(7).format('YYYY-MM-DD')
      } else if (value == 'alltime') {
        this.dateRange.start = this.campaign.start
        this.dateRange.end = this.campaign.end
      } else if (value == '7-days') {
        this.dateRange.end = moment().utcOffset(7).format('YYYY-MM-DD')
        this.dateRange.start = moment(this.dateRange.end).subtract(6, 'days').format('YYYY-MM-DD')
      } else if (value == '30-days') {
        this.dateRange.end = moment().utcOffset(7).format('YYYY-MM-DD')
        this.dateRange.start = moment(this.dateRange.end).subtract(29, 'days').format('YYYY-MM-DD')
      }
    },
    'dateRange': {
      handler: function(newVal, oldVal) {
        // Convert to handle custom date case
        if (oldVal) {
          this.loadData()
        }
      },
      deep: true
    },
  },
  beforeCreate() {
    
  },
  created() {
    this.orderId = this.$route.params.id
  },
  beforeMount() {

  },
  async mounted() {
    this.query_router = this.$route.query
    await this.loadData()
    this.setCampaignPeriod()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    goToAllCampaign() {
      this.$router.push({ name: 'advertiserbus', query : this.query_router})
    },
    async loadData() {
      // Get campaign and measurement data
      this.isLoading = true
      this.loaded = false
      this.chartData = []

      const params = {
        start: this.dateRange.start,
        end: this.dateRange.end
      }

      const { data, status } = await api.get(apiUrls.busMeasurementSummary(this.orderId), 
      { params: params, 
        needToken: false,
        useMeasurement: true
      })

      if (status === 200) {
        this.campaign = { ...data.campaign }
        this.startPeriod = data.campaign.start
        this.endPeriod = data.campaign.end
        this.measurementData = _.orderBy(data.measurement, obj => {
          return moment(moment(obj.date).format('YYYY-MM-DD'))
        }, ['asc'])
  
        // Calculate total measurement
        let snap = this.measurementData.reduce((prev, curr) => prev + (parseInt(curr.totalSnap) || 0), 0)
        let fair = this.measurementData.reduce((prev, curr) => prev + (parseInt(curr.totalFair) || 0), 0)
        let captive = this.measurementData.reduce((prev, curr) => prev + (parseInt(curr.totalCaptive) || 0), 0)
        let distance = this.measurementData.reduce((prev, curr) => prev + (parseInt(curr.totalKm) || 0), 0)
        let totalImpression = snap + fair + captive
  
        let snapPercentage = Math.round((snap/totalImpression + 0.00001) * 100)
        let fairPercentage = Math.round((fair/totalImpression + 0.00001) * 100)
        let captivePercentage = Math.round(100 - snapPercentage - fairPercentage)
  
        this.totalMeasurement = {
          impression: totalImpression,
          snap: snapPercentage,
          fair: fairPercentage,
          captive: captivePercentage,
          distance: distance
        }
  
        this.filterData(this.measurementData)
      } else {
        this.isLoading = false
      }
    },
    async filterData(data) {
      // Filter data based on time filter
      this.loaded = false
      this.chartData = []
      let items = data
      let filteredData = []

      // Change graph by selected type. TODO: Refactor it later, it can be changed to a separated function.
      let firstDate = null
      let lastDate = null

      switch (this.selectedFilter) {
        case 'day':
          if (this.selectedType == 'impression') {
            filteredData = await items.map(item => parseInt(item.totalSnap) + parseInt(item.totalFair) + parseInt(item.totalCaptive))
          } else {
            filteredData = await items.map(item => parseInt(item[this.selectedType]))
          }

          this.chartData = {
            labels: await items.map(item => moment(item.date).format('DD MMM')),
            datasets: [{
              backgroundColor: 'transparent',
              borderColor: '#FF2D55',
              data: filteredData
            }]
          }
          this.loaded = true
          this.isLoading = false
          this.passProps()
          break;
        case 'week':
          let weekItems = []

          if (items.length <= 1) {
            weekItems.push({
              date: moment(items[0].date).format('DD MMM') + ' - ' + moment(items[0].date).add(6, 'days').format('DD MMM'),
              totalSnap: items[0].totalSnap,
              totalFair: items[0].totalFair,
              totalCaptive: items[0].totalCaptive,
              totalKm: items[0].totalKm
            })
          } else {
            firstDate = items[0].date
            lastDate = items[items.length - 1].date

            while (moment(firstDate).format('YYYY-MM-DD') <= moment(lastDate).format('YYYY-MM-DD')) {
              let nextWeek = moment(firstDate).add(6, 'days')
              let weeks = items.filter(item => moment(firstDate).format('YYYY-MM-DD') <= moment(item.date).format('YYYY-MM-DD') && moment(item.date).format('YYYY-MM-DD') <= moment(nextWeek).format('YYYY-MM-DD'))

              let snap = weeks.reduce((prev, curr) => prev + (parseInt(curr.totalSnap) || 0), 0)
              let fair = weeks.reduce((prev, curr) => prev + (parseInt(curr.totalFair) || 0), 0)
              let captive = weeks.reduce((prev, curr) => prev + (parseInt(curr.totalCaptive) || 0), 0)
              let distance = weeks.reduce((prev, curr) => prev + (parseInt(curr.totalKm) || 0), 0)
              let date = moment(firstDate).format('DD MMM') + ' - ' + moment(nextWeek).format('DD MMM')

              weekItems.push({
                date: date,
                totalSnap: snap,
                totalFair: fair,
                totalCaptive: captive,
                totalKm: distance
              })

              firstDate = moment(nextWeek).add(1, 'days')
            }
          }

          // Filter graph data based on selected type
          if (this.selectedType == 'impression') {
            filteredData = await weekItems.map(item => parseInt(item.totalSnap) + parseInt(item.totalFair) + parseInt(item.totalCaptive))
          } else {
            filteredData = await weekItems.map(item => parseInt(item[this.selectedType]))
          }

          this.chartData = {
            labels: await weekItems.map(item => item.date),
            datasets: [{
              backgroundColor: 'transparent',
              borderColor: '#FF2D55',
              data: filteredData
            }]
          }
          this.loaded = true
          this.isLoading = false
          this.passProps()
          break;
        case 'month':
          let monthItems = []

          if (items.length <= 1) {
            monthItems.push({
              date: moment(items[0].date).format('MMMM') + ' - ' + moment(items[0].date).add(1, 'month').format('MMMM'),
              totalSnap: items[0].totalSnap,
              totalFair: items[0].totalFair,
              totalCaptive: items[0].totalCaptive,
              totalKm: items[0].totalKm
            })
          } else {
            firstDate = items[0].date
            lastDate = items[items.length - 1].date

            while (moment(firstDate).format('YYYY-MM') <= moment(lastDate.date).format('YYYY-MM')) {
              let nextMonth = moment(firstDate).add(1, 'month')
              let months = items.filter(item => moment(item.date).format('YYYY-MM') === moment(firstDate).format('YYYY-MM'))
  
              let snap = months.reduce((prev, curr) => prev + (parseInt(curr.totalSnap) || 0), 0)
              let fair = months.reduce((prev, curr) => prev + (parseInt(curr.totalFair) || 0), 0)
              let captive = months.reduce((prev, curr) => prev + (parseInt(curr.totalCaptive) || 0), 0)
              let distance = months.reduce((prev, curr) => prev + (parseInt(curr.totalKm) || 0), 0)
              let date = moment(firstDate).format('MMMM')
  
              monthItems.push({
                date: date,
                totalSnap: snap,
                totalFair: fair,
                totalCaptive: captive,
                totalKm: distance
              })
  
              firstDate = nextMonth
            }
          }

          // Filter graph data based on selected type
          if (this.selectedType == 'impression') {
            filteredData = await monthItems.map(item => parseInt(item.totalSnap) + parseInt(item.totalFair) + parseInt(item.totalCaptive))
          } else {
            filteredData = await monthItems.map(item => parseInt(item[this.selectedType]))
          }

          this.chartData = {
            labels: await monthItems.map(item => item.date),
            datasets: [{
              backgroundColor: 'transparent',
              borderColor: '#FF2D55',
              data: filteredData
            }]
          }
          this.loaded = true
          this.isLoading = false
          this.passProps()
          break;
      }
    },
    selectFilter(value) {
      this.selectedFilter = value
      if (value) {
        if (this.measurementData.length) this.filterData(this.measurementData)
      }
    },
    selectDateFilter(item) {
      if (item.value != this.selectedDate){
        this.selectedDate = item.value
      }
    },
    toggleTo(selected) {
      if (selected != this.selectedType) {
        this.isLoading = true
        this.loaded = false

        // Handle toggling status
        Object.keys(this.toggle).map((key, index) => {
          if (key == selected) {
            this.toggle[key] = true
            this.selectedType = selected
            if (this.measurementData.length) this.filterData(this.measurementData)
          } else {
            this.toggle[key] = false
          }
        })
        
        this.isLoading = false
      }
    },
    passProps(){
      this.startParam = this.dateRange.start || this.campaign.start
      this.endParam = this.dateRange.end || this.campaign.end
      this.childParam = `${this.startParam} - ${this.endParam}`
    },
    displayPercentage(value) {
      return value + '%'
    },
    displayKilometers(value) {
      return this.getFormatNumber(Math.round(value * 10) / 10)
    },
    getFormatNumber(value){
      return formatMoney(value, { symbol: ``, precision: 0, thousand: `.` })
    },
    setCampaignPeriod() {
      this.dateRange.start = moment(this.startPeriod).format('YYYY-MM-DD')
      this.dateRange.end = moment(this.endPeriod).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';

 .busReport__report__content{
   .coverage, .routes, .vehicle{
     max-height: 300px;
      overflow: scroll;
   }
 }

</style>
